import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "doctorFormIsOpen", false);
        Vue.set(state, "doctorGridIsOpen", true);
        Vue.set(state, "examFormIsOpen", false);
        Vue.set(state, "examGridIsOpen", false);
        Vue.set(state, "languageFormIsOpen", false);
        Vue.set(state, "languageGridIsOpen", false);
        Vue.set(state, "feeFormIsOpen", false);
        Vue.set(state, "feeGridIsOpen", false);
    },

    setDoctorFormOpen(state) {
        state.doctorFormIsOpen = true;
        state.doctorGridIsOpen = false;
    },
    setDoctorFormClose(state) {
        state.doctorFormIsOpen = false;
        state.doctorGridIsOpen = true;
    },

    setExamFormOpen(state) {
        state.examFormIsOpen = true;
        state.examGridIsOpen = false;
    },
    setExamFormClose(state) {
        state.examFormIsOpen = false;
        state.examGridIsOpen = true;
    },
    setExamGridOpen(state) {
        state.examFormIsOpen = false;
        state.examGridIsOpen = true;
        state.doctorGridIsOpen = false;
    },
    setExamGridClose(state) {
        state.examFormIsOpen = false;
        state.examGridIsOpen = false;
        state.doctorGridIsOpen = true;
    },
    setLanguageGridOpen(state) {
        state.languageFormIsOpen = false;
        state.languageGridIsOpen = true;
        state.doctorGridIsOpen = false;
    },
    setLanguageGridClose(state) {
        state.languageFormIsOpen = false;
        state.languageGridIsOpen = false;
        state.doctorGridIsOpen = true;
    },
    setLanguageFormOpen(state) {
        state.languageFormIsOpen = true;
        state.languageGridIsOpen = false;
    },
    setLanguageFormClose(state) {
        state.languageFormIsOpen = false;
        state.languageGridIsOpen = true;
    },

    setFeeFormOpen(state) {
        state.feeFormIsOpen = true;
        state.feeGridIsOpen = false;
    },
    setFeeFormClose(state) {
        state.feeFormIsOpen = false;
        state.feeGridIsOpen = true;
    },
    setFeeGridOpen(state) {
        state.feeFormIsOpen = false;
        state.feeGridIsOpen = true;
        state.doctorGridIsOpen = false;
    },
    setFeeGridClose(state) {
        state.feeFormIsOpen = false;
        state.feeGridIsOpen = false;
        state.doctorGridIsOpen = true;
    }
}
